exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatars[data-v-1b3edc60] {\n  margin-left: 10px;\n}\n.avatars .custom-avatar-wrapper[data-v-1b3edc60] {\n  margin-left: -10px;\n}\n.avatars .ant-avatar[data-v-1b3edc60] {\n  border: 1px solid white;\n}\n.avatars .overflow .ant-avatar[data-v-1b3edc60] {\n  background-color: #085FCE;\n  color: white;\n  font-weight: 500;\n  font-size: 14px;\n}", ""]);

// exports
